export function getCustomerSuccessState({
  clients = [],
  jobs = [],
  estimates = [],
  invoices = [],
  payments = [],
  receipts = [],
  context = "home",
}) {
  const clientCount = Array.isArray(clients) ? clients.length : 0;
  const jobCount = Array.isArray(jobs) ? jobs.length : 0;
  const estimateCount = Array.isArray(estimates) ? estimates.length : 0;
  const invoiceCount = Array.isArray(invoices) ? invoices.length : 0;
  const paymentCount = Array.isArray(payments) ? payments.length : 0;
  const receiptCount = Array.isArray(receipts) ? receipts.length : 0;

  if (clientCount === 0) {
    return {
      key: "first-client",
      context: "home",
      step: 1,
      total: 5,
      title: "Create your first client",
      body:
        "Every successful contractor starts with a customer. Add your first client so JobTelesis can help you create jobs, estimates, invoices, payments, and receipts.",
      primaryLabel: "Create Client",
      helpLabel: "Help: Create your first client",
      action: "create-client",
    };
  }

  if (jobCount === 0) {
    return {
      key: "first-job",
      context: "home",
      step: 2,
      total: 5,
      title: "Create your first Job",
      body:
        "Great start. Now create a Job for your client so you can track the work from estimate to invoice, payment, and receipt.",
      primaryLabel: "Create Job",
      helpLabel: "Help: Create your first Job",
      action: "create-job",
    };
  }

  if (context === "job-detail" && estimateCount === 0 && invoiceCount === 0) {
    return {
      key: "first-estimate-or-invoice",
      context: "job-detail",
      step: 3,
      total: 5,
      title: "Create your first Estimate, or skip to Invoice",
      body:
        "An Estimate helps your customer approve the work before billing. If pricing is already agreed, you can skip the Estimate and create an Invoice now.",
      primaryLabel: "Create Estimate",
      secondaryLabel: "Skip to Invoice",
      helpLabel: "Help: Create your first Estimate or Invoice",
      action: "create-estimate",
      secondaryAction: "create-invoice",
    };
  }

  if (context === "job-detail" && estimateCount > 0 && invoiceCount === 0) {
    return {
      key: "first-invoice",
      context: "job-detail",
      step: 4,
      total: 5,
      title: "Create your first Invoice",
      body:
        "Great work. Your estimate is ready. When the customer approves the work, create an Invoice so you can get paid.",
      primaryLabel: "Create Invoice",
      helpLabel: "Help: Create your first Invoice",
      action: "create-invoice",
    };
  }

  if (context === "job-detail" && invoiceCount > 0 && paymentCount === 0) {
    return {
      key: "first-payment",
      context: "job-detail",
      step: 5,
      total: 5,
      title: "Receive your first Payment",
      body:
        "Excellent. Your invoice is ready. Now record your first payment so JobTelesis can complete the revenue cycle.",
      primaryLabel: "Record Payment",
      helpLabel: "Help: Receive your first Payment",
      action: "record-payment",
    };
  }

  if (context === "job-detail" && paymentCount > 0 && receiptCount === 0) {
    return {
      key: "first-receipt",
      context: "job-detail",
      step: 5,
      total: 5,
      title: "Send your first Receipt",
      body:
        "Congratulations. Your first payment has been recorded. Send a receipt so your customer has a clean record of payment.",
      primaryLabel: "Send Receipt",
      helpLabel: "Help: Send your first Receipt",
      action: "send-receipt",
    };
  }

  return null;
}

export function getFirstCustomerSuccessMission(args) {
  return getCustomerSuccessState({ ...args, context: "home" });
}
